module.exports = __webpack_public_path__ + "static/img/icon_search@2x.bfe3c369.png";